export default __webpack_public_path__ + "static/media/chevron-left.98bda50b.svg";